import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import {
  Button,
  Divider,
  Drawer,
  FormLabel,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Website } from '@/types/website';
import { useAppDispatch } from '@/hooks';
import { updateOrganizationWebsite } from '@/features/organizations/slice';

interface Props {
  selectedWebsite?: Website;
  onClose: () => void;
}

const WebsiteSettings = ({ selectedWebsite, onClose }: Props) => {
  const { organizationId } = useParams();
  const dispatch = useAppDispatch();

  const formik = useFormik({
    initialValues: {},

    onSubmit: async (values: Website) => {
      if (!organizationId) return;
      const payload = {
        organizationId: organizationId,
        website: { ...values },
      };
      await dispatch(updateOrganizationWebsite(payload));
      onClose();
    },
  });

  useEffect(() => {
    if (selectedWebsite) {
      formik.setValues({ ...selectedWebsite });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedWebsite]);

  return (
    <Drawer
      open={!!selectedWebsite}
      onClose={onClose}
      anchor="right"
      PaperProps={{ sx: { width: 600 } }}
    >
      <Stack padding={3} direction="row" justifyContent={'space-between'}>
        <Typography>Website Settings</Typography>
        <Stack direction={'row'} spacing={2} alignItems={'center'}>
          <Button onClick={onClose}>Cancelar</Button>
          <Button color="success" type="submit" onClick={formik.handleSubmit}>
            Guardar
          </Button>
        </Stack>
      </Stack>
      <Divider />

      <Stack spacing={2} padding={3}>
        <TextField
          label="Nombre"
          margin="normal"
          name="title"
          value={formik.values.title}
          onChange={formik.handleChange}
        />
        <Stack spacing={2}>
          <FormLabel>Estado</FormLabel>
          <Typography>
            {formik.values.isPublished === true ? 'Publicado' : 'privado'}
          </Typography>

          <FormLabel>Plantilla</FormLabel>
          <Typography variant="h5">{formik.values.template}</Typography>

          <FormLabel>Creado por</FormLabel>
          <Typography variant="h5">{formik.values.createdBy}</Typography>

          <FormLabel>Actualizado por</FormLabel>
          <Typography variant="h5">{formik.values.lastUpdatedBy}</Typography>
        </Stack>
      </Stack>
    </Drawer>
  );
};

export default WebsiteSettings;
